/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface UserTokens
 */
export interface UserTokens {
  /**
   *
   */
  user: number;
  /**
   * The user ID in the external identity provider, which is present as the 'sub' field in tokens.
   */
  externalUserId: string;
  /**
   *
   */
  readonly created?: Date;
  /**
   * The last time this remote user logged in.
   */
  readonly lastModified?: Date;
  /**
   * The most recent ID token provided by the external identity provider.
   */
  idToken?: string;
  /**
   * The most recent access token provided by the external identity provider.
   */
  accessToken?: string;
  /**
   * The most recent refresh token provided by the external identity provider.
   */
  refreshToken?: string;
}

/**
 * Check if a given object implements the UserTokens interface.
 */
export function instanceOfUserTokens(value: object): value is UserTokens {
  if (!("user" in value) || value["user"] === undefined) return false;
  if (
    (!("externalUserId" in (value as Record<string, any>)) &&
      !("external_user_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["externalUserId"] === undefined &&
      (value as Record<string, any>)["external_user_id"] === undefined)
  )
    return false;
  return true;
}

export function UserTokensFromJSON(json: any): UserTokens {
  return UserTokensFromJSONTyped(json, false);
}

export function UserTokensFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTokens {
  if (json == null) {
    return json;
  }
  return {
    user: json["user"],
    externalUserId: json["external_user_id"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    lastModified: json["last_modified"] == null ? undefined : parseDateTime(json["last_modified"]),
    idToken: json["id_token"] == null ? undefined : json["id_token"],
    accessToken: json["access_token"] == null ? undefined : json["access_token"],
    refreshToken: json["refresh_token"] == null ? undefined : json["refresh_token"],
  };
}

export function UserTokensToJSON(json: any): UserTokens {
  return UserTokensToJSONTyped(json, false);
}

export function UserTokensToJSONTyped(
  value?: Omit<UserTokens, "created" | "lastModified"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    user: value["user"],
    external_user_id: value["externalUserId"],
    id_token: value["idToken"],
    access_token: value["accessToken"],
    refresh_token: value["refreshToken"],
  };
}
